import React from 'react';
import {StyleSheet, View, Text, TouchableOpacity} from 'react-native';
import {Icon} from 'src/components';
import {colors} from 'src/assets';

export type RowProps = {
  text: string;
  selected?: boolean;
  onPress?: () => void;
};

export const Row: React.FC<RowProps> = ({text, selected, onPress}) => {
  return (
    <TouchableOpacity
      style={[styles.container, selected ? styles.containerSelected : {}]}
      onPress={onPress}>
      <View style={styles.content}>
        <Text style={[styles.text, selected ? styles.textSelected : {}]}>
          {text}
        </Text>
        <View style={styles.rightContainer}>
          {selected ? (
            <Icon
              style={styles.rightIcon}
              name={'check'}
              color={colors.chokuRed}
              size={24}
            />
          ) : null}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: colors.gray1,
    flexDirection: 'column',
    borderBottomColor: colors.white,
    borderBottomWidth: 1,
  },
  containerSelected: {
    backgroundColor: '#FFF4F1',
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    color: colors.chokuGray,
    fontSize: 14,
    marginRight: 16,
  },
  textSelected: {
    color: colors.chokuRed,
  },
  rightContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  rightIcon: {
    marginLeft: 8,
  },
});
